<template>
  <div
    class="custom-svg"
    @click="changeStatus">
    <svg
      v-if="!isActive"
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink">
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd">
        <g
          id="后台-打开"
          transform="translate(-271.000000, -25.000000)">
          <rect
            fill="#1C1E2F"
            x="0"
            y="0"
            width="1671"
            height="2433"/>
          <rect
            id="Rectangle-21"
            fill="#292B42"
            fill-rule="nonzero"
            x="0"
            y="0"
            width="1671"
            height="74"/>
          <g
            id="Group-31"
            transform="translate(271.000000, 25.000000)"
            fill="#FFFFFF"
            fill-rule="nonzero">
            <g
              id="收起-copy"
              transform="translate(2.000000, 4.000000)">
              <path
                id="Shape"
                :d="path1"/>
            </g>
          </g>
        </g>
      </g>
    </svg>
    <svg
      v-else
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink">
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd">
        <g
          id="后台-收起"
          transform="translate(-107.000000, -25.000000)">
          <rect
            fill="#1C1E2F"
            x="0"
            y="0"
            width="1671"
            height="2433"/>
          <rect
            id="Rectangle-21"
            fill="#292B42"
            fill-rule="nonzero"
            x="0"
            y="0"
            width="1671"
            height="74"/>
          <g
            id="Group-31"
            transform="translate(107.000000, 25.000000)"
            fill="#FFFFFF"
            fill-rule="nonzero">
            <g
              id="收起-copy"
              transform="translate(3.000000, 4.000000)">
              <path
                id="Shape"
                :d="path2"/>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      path1: `M15.96875,1.333 C15.96875,2.069 15.37175,2.667 14.63575,2.667 L1.30175,2.667 C0.579496789,2.64721966 0.00427054216,2.05602402 0.00427054216,1.3335 C0.00427054216,0.610975978 0.579496789,0.0197803366 1.30175,0 L14.63575,0 C15.37175,0 15.96875,0.597 15.96875,1.333 Z M11.96875,8 C11.96875,8.736 11.37175,9.333 10.63575,9.333 L1.30175,9.333 C0.579496789,9.31321966 0.00427054216,8.72202402 0.00427054216,7.9995 C0.00427054216,7.27697598 0.579496789,6.68578034 1.30175,6.666 L10.63575,6.666 C11.37175,6.667 11.96875,7.265 11.96875,8 Z M15.96875,14.667 C15.96875,15.403 15.37175,16 14.63575,16 L1.30175,16 C0.579496789,15.9802197 0.00427054216,15.389024 0.00427054216,14.6665 C0.00427054216,13.943976 0.579496789,13.3527803 1.30175,13.333 L14.63575,13.333 C15.37175,13.333 15.96875,13.931 15.96875,14.667 Z M16.235774,10.799907 L18.902174,8.799982 C19.3439919,8.46859789 19.4335161,7.84179386 19.102132,7.399976 C19.0452875,7.32418812 18.9779619,7.25686246 18.902174,7.200018 L16.235774,5.20009301 C15.7939561,4.8687089 15.1671521,4.95823315 14.835768,5.400051 C14.7059345,5.57315149 14.63575,5.78369453 14.63575,6.00007501 L14.63575,9.99992499 C14.63575,10.5522097 15.0834653,10.999925 15.63575,10.999925 C15.8521305,10.999925 16.0626735,10.9297405 16.235774,10.799907 Z`,
      path2: `M15.1703125,1.26635 C15.1703125,1.96555 14.6031625,2.53365 13.9039625,2.53365 L1.2366625,2.53365 C0.55052195,2.51485868 0.00405701506,1.95322282 0.00405701506,1.266825 C0.00405701506,0.580427179 0.55052195,0.0187913198 1.2366625,0 L13.9039625,0 C14.6031625,0 15.1703125,0.56715 15.1703125,1.26635 Z M11.3703125,7.6 C11.3703125,8.2992 10.8031625,8.86635 10.1039625,8.86635 L1.2366625,8.86635 C0.55052195,8.84755868 0.00405701506,8.28592282 0.00405701506,7.599525 C0.00405701506,6.91312718 0.55052195,6.35149132 1.2366625,6.3327 L10.1039625,6.3327 C10.8031625,6.33365 11.3703125,6.90175 11.3703125,7.6 Z M15.1703125,13.93365 C15.1703125,14.63285 14.6031625,15.2 13.9039625,15.2 L1.2366625,15.2 C0.55052195,15.1812087 0.00405701506,14.6195728 0.00405701506,13.933175 C0.00405701506,13.2467772 0.55052195,12.6851413 1.2366625,12.66635 L13.9039625,12.66635 C14.6031625,12.66635 15.1703125,13.23445 15.1703125,13.93365 Z M17.3702885,10.199907 L14.9705385,8.399982 C14.5287206,8.06859789 14.4391964,7.44179386 14.7705805,6.999976 C14.827425,6.92418812 14.8947506,6.85686246 14.9705385,6.800018 L17.3702885,5.00009301 C17.8121064,4.6687089 18.4389104,4.75823315 18.7702945,5.200051 C18.900128,5.37315149 18.9703125,5.58369453 18.9703125,5.80007501 L18.9703125,9.39992499 C18.9703125,9.95220974 18.5225972,10.399925 17.9703125,10.399925 C17.753932,10.399925 17.543389,10.3297405 17.3702885,10.199907 Z`
    };
  },
  methods: {
    changeStatus() {
      this.$emit('click', this.isActive);
    }
  }
};
</script>
<style lang='less' scoped>
.custom-svg svg{
  transform: translateY(4px);
}
</style>




// WEBPACK FOOTER //
// src/components/Hamburger/index.vue?1e0034db